import React from "react";
import './modal.css';

export const PopUp = ({ handleClose, show, children }) => {
  const showHideClassName = show ? "modal display-block" : "modal display-none";

  return (
       <div className={showHideClassName}>
       {/* <div className="modal display-block"> */}
        <section className="modal-main">
          {children}
          <div className="row justify-content-md-center" styles={{height:"40px"}}>
          <p> </p>
          </div>
          <div className="row justify-content-md-center">
            <input type="button" className="btn btn-primary" value="Chiudi" onClick={handleClose} style={{alignItems:'center'}}></input>
          </div>
        </section>
      </div>
  );
};

